import React from 'react';
import styledComponent from '../utils/styledComponent';

const StyledPageViewContainer = styledComponent('main', {
  height: '100vh',
  width: '100vw',
  maxWidth: '100vw',
  maxHeight: '100vh',
  padding: '0 84px',
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: 'column',
  '@media (max-width: 768px)': {
    padding: '0 24px',
  },
});

const PageViewContainer = ({ children, className = '' }) => {
  return (
    <StyledPageViewContainer className={className}>
      {children}
    </StyledPageViewContainer>
  );
};

export default PageViewContainer;
